import IamApi from "api/IamApi";
import { VALIDATE_NAMESPACE } from "constants/i18n-namespaces";
import { useBiller } from "hooks";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import routing from "routing";
import { getDeviceFingerprint } from "selectors/appState";
import FundingOption from "constants/FundingOption";
import { ISession } from "types/session";
import { getDomain, mapSessionLanguageToUiLanguage } from "utilities/helper";

export const SmsBarcodeDirectLanding = () => {
  const fingerprint = useSelector(getDeviceFingerprint);
  const [searchParams] = useSearchParams();
  const { loadBiller, getBiller } = useBiller();
  const biller = getBiller();
  const { login } = useOutletContext<ISession>();
  const { i18n } = useTranslation(VALIDATE_NAMESPACE);

  const navigate = useNavigate();
  const domain = getDomain();
  const payableKrn = searchParams.get("payableKrn");
  const hash = searchParams.get("hash");
  const spaceKrn = searchParams.get("spaceKrn");
  const language = searchParams.get("language");

  useEffect(() => {
    if (biller === null || biller === undefined) {
      loadBiller();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const smsBarcodeDirectLanding = async () => {
      if (payableKrn && spaceKrn && hash && language) {
        IamApi.ezpay
          .getPayableBarcodeLanding(
            fingerprint,
            navigator.userAgent,
            domain,
            spaceKrn,
            language,
            biller.clientId,
            {
              payableKrn: payableKrn,
              hash: hash,
            },
          )
          .then((response) => {
            const payable = response.data;
            login({ ...payable, fingerprint: fingerprint });
            const selectedLanguage = mapSessionLanguageToUiLanguage(
              language ?? "en"
            );
            i18n.changeLanguage(selectedLanguage);

            // Navigate user to: payableCash if multiple payment options are available OR 
            // payableDashboard if client is configured as cash only (yet to be implemented)

            if (payable.fundingOptions.length > 1) {
              navigate(routing.payableCash.index());
            } else if (payable.fundingOptions.length === 1 && payable.fundingOptions.includes(FundingOption.Cash)) {
              navigate(routing.payableDashboard.index());
            }

          })
          .catch((error) => {
            console.log(error);
            // should be replace by error page once it is ready
            navigate(routing.index());
          });
      } else {
        navigate(routing.index());
      }
    };

    if (biller) {
      smsBarcodeDirectLanding();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [biller]);

  return <></>;
};

export default SmsBarcodeDirectLanding;
